module.exports = __webpack_public_path__ + "img/nodata.49d6fd82.png";